import { WEEK_DAY_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingOpeningHours } from 'shared/types/buildingCard';

export interface IMergedOpeningHours {
  /** Подписи дней через «, »: «Пн, Вт», «Рабочие дни» */
  label: string;
  from: string | null;
  to: string | null;
  roundTheClock: boolean;
}

/**
 * Склейка интервалов с одинаковым временем. Порт `merge_opening_hours` (`cian/business_shopping_centers/presenters.py`).
 * Интервал без типа или с неизвестным типом пропускаем: в монолите он ронял весь список
 */
export function mergeOpeningHours(hours: IBuildingOpeningHours[]): IMergedOpeningHours[] {
  return hours.reduce<IMergedOpeningHours[]>((merged, { type, from, to, roundTheClock }) => {
    const label = type ? WEEK_DAY_LABELS[type] : undefined;

    if (!label) {
      return merged;
    }

    const same = merged.find(item => item.from === from && item.to === to && item.roundTheClock === roundTheClock);

    if (same) {
      same.label = `${same.label}, ${label}`;
    } else {
      merged.push({ label, from, to, roundTheClock });
    }

    return merged;
  }, []);
}
